import React from "react";
import TextField from "@material-ui/core/TextField";
import config from "../../../../config";
import CircularProgress from "@material-ui/core/CircularProgress";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";

const log = console.log;

const useStyles = makeStyles(() => ({
  popper: () => ({
    zIndex: 1501,
  }),
}));

const ImportViewer = (props) => {
  const classes = useStyles();
  const [fetchHistory, setFetchHistory] = React.useState([]);
  const [blueprint, setBluePrint] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [importBpOptionValidation, setImportBpOptionValidation] = React.useState(null);
  const [defaultBpName, setDefaultBpName] = React.useState("");
  const [defaultBpDesc, setDefaultBpDesc] = React.useState("");



  React.useEffect(() => {
    asyncComponentDidMount();
  }, []);

  const asyncComponentDidMount = async () => {
    try {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", localStorage.getItem("token") || null);
      const requestOptions = { method: "GET", headers: myHeaders };
      
      // const url = config.apiUrl + "/import-history";
      const url = config.apiUrl + "/template-blueprint-list";
      
      const response = await fetch(url, requestOptions);
      const json = await response.json();
      if (json.data.length) setFetchHistory(json.data);
      // else setFetchHistory([{ title: "Swarms", value: "swarms" }]);

      setLoading(false);
    } catch (error) {
      log("[error]: ", error);
    }
  };

  const handleChange = (value) => {
    setBluePrint(value);
    if (value != null) {
      setImportBpOptionValidation(null)
      props.setImportBpOptionsValidation(true);
    }
    else {
      setImportBpOptionValidation("Please select a blueprint template.")
      props.setImportBpOptionsValidation(false);
    }
  };




  React.useEffect(() => {
    if (Boolean(blueprint)) {
      props.setCloneBlueprintName(blueprint.title)
      props.setCloneBlueprintDesc(blueprint.description)
      props.selectedBlueprint.current = blueprint.id || blueprint.value;
      props.forceUpdate();
      setDefaultBpName(blueprint.title)
      setDefaultBpDesc(blueprint.description)
    }
  
  }, [blueprint]);

  return (
    <React.Fragment>
      <Autocomplete
        fullWidth
        classes={{ popper: classes.popper, paper: classes.popper }}
        options={fetchHistory}
        getOptionLabel={(option) => option.title}
        loading={loading}
        disablePortal
        disabled={loading}
        onChange={(event, value, reason) => handleChange(value)}
        renderInput={(params) => (
          <TextField
            {...params}
            require
            autoFocus
            label="Select a template"
            variant="outlined"
            name={"importBlueprint"}
            helperText={blueprint && blueprint.id ? blueprint.description : ""}
            InputProps={{
              ...params.InputProps,
              shrink: true,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />

      <br />
      <br />
      <TextField
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          pattern: "^S+$",
        }}
        type={"text"}
        fullWidth
        required
        label={"Blueprint Name"}
        key={defaultBpName}
        defaultValue={defaultBpName}
        placeholder={"Blueprint Name"}
        variant="outlined"
        name={"blueprintName"}
        onChange={(event) => {
          props.setCloneBlueprintName(event.target.value);
        }}
      />
      <br />
      <br />
    
      <TextField
        InputLabelProps={{
          shrink: true,
        }}
        type={"text"}
        fullWidth
        required
        label="Multiline"
        multiline
        rows={4}
        label={"Description"}
        defaultValue={defaultBpDesc}
        placeholder={"Description"}
        variant="outlined"
        name={"Description"}
        onChange={(event) => props.setCloneBlueprintDesc(event.target.value)}
      />
    </React.Fragment>
  );
};

export default ImportViewer;
